export default "__VITE_ASSET__4755c691__"